import { classNames } from '@library/utils';

export interface PageTitleProps {
  subtitle?: string;
  title: string;
  className?: string;
}

export const PageTitle = ({
  title,
  subtitle = '',
  className = ''
}: PageTitleProps) => {
  return subtitle ? (
    <>
      <h5
        className={classNames(
          'text-soFresh-190 text-start font-semibold',
          className
        )}
      >
        {title}
      </h5>
      <h1
        className={classNames(
          'text-soClean-100 text-start text-xl font-semibold',
          className
        )}
      >
        {subtitle}
      </h1>
    </>
  ) : (
    <h1
      className={classNames(
        'text-soClean-100 flex-1 text-start text-2xl font-semibold',
        className
      )}
    >
      {title}
    </h1>
  );
};
